export default __webpack_public_path__ + "static/media/brandIcon.d98bc202.svg";